import servers from "./servers";

export default {
  [servers.user]: "https://preuser-api.jilingshu.com.cn",
  [servers.exam]: "https://preexam-center-service.jilingshu.com.cn",
  [servers.device]: "https://preapi.jilingshu.com.cn",
  [servers.authorization]: "https://preapi.jilingshu.com.cn",
};
